module.exports = __webpack_public_path__ + "img/fstvideo.1afc8cde.png";